package horcrux.frontend.common.views.navigation

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.views.auth.AuthDialog
import horcrux.frontend.common.views.auth.VerifyEmailDialog
import react.FC
import react.PropsWithChildren

external interface ViewWithNavigationBarProps : PropsWithChildren {
    var route: Route
    var globalAppState: GlobalAppState
}

val ViewWithNavigationBar = FC<ViewWithNavigationBarProps> { props ->
    NavigationBar {
        this.route = props.route
        this.globalAppState = props.globalAppState
    }
    AuthDialog {
        this.globalAppState = props.globalAppState
    }
    VerifyEmailDialog {
        this.globalAppState = props.globalAppState
    }
    ScrollToEndButtons {}
    +props.children
}
